import { Text } from '@mantine/core';
import { useSelector } from 'react-redux';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    defaultWorkflowRepresentationResource,
    useWorkflowRepresentationActions,
    WorkflowRepresentationMutationResourceSchema,
} from '../../../../../resource/resources/artifacts/use_case/representation/workflowRepresentationResource';
import { Form_EditableViewWrapper } from '../../../../reusable-components/form-components/Form_EditableViewWrapper';
import { ResourceValidationTitleBar } from '../../../../reusable-components/validation/ResourceValidationTitleBar';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import { WorkflowRepresentationContent } from './WorkflowRepresentationContent';

export const WorkflowRepresentationView = ({
    id,
}: {
    id: string | undefined;
    projectId: string | undefined;
    projectVersionId: string | undefined;
}) => {
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const workflowRepresentationActions = useWorkflowRepresentationActions();
    const workflowRepresentationQuery = workflowRepresentationActions.useGetResource(id);
    const updateWorkflowRepresentation = workflowRepresentationActions.useUpdateResource();
    const validateWorkflowRepresentation = workflowRepresentationActions.useValidateResource(id, validationScope);

    const { form, formNames, onSubmit } = useMyForm({
        schema: WorkflowRepresentationMutationResourceSchema,
        defaultValues: defaultWorkflowRepresentationResource,
        submitHandler: async (data) => {
            await updateWorkflowRepresentation.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: workflowRepresentationQuery.data,
    });

    return (
        <QueryBaseComponent name="WorkflowRepresentation" query={workflowRepresentationQuery}>
            <Form_EditableViewWrapper form={form} onSubmit={onSubmit}>
                <ResourceValidationTitleBar
                    resourceValidationResult={validateWorkflowRepresentation.data}
                    metaDataInfo={workflowRepresentationQuery.data}
                    resourceType={ResourceType.WORKFLOW_REPRESENTATION}
                >
                    <Text c="dimmed">Workflow Representation</Text>
                </ResourceValidationTitleBar>
                <WorkflowRepresentationContent form={form} formNames={formNames} id={id} readOnly={readOnly} />
            </Form_EditableViewWrapper>
        </QueryBaseComponent>
    );
};
